var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeekrPrimaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 45,
    viewBox: "0 0 180 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8144 39.9706H29.8261V26.5107L18.8377 15.6201V3.6302H40.8016L40.8144 39.9706ZM4.19074 39.9706V3.6302H15.1663V17.1157L26.1546 28.0063V39.9578L4.19074 39.9706ZM44.473 0H0.532227V43.6007H44.473V0Z",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7693 14.7266L67.3816 26.5119H78.1767V28.915H61.4043V28.864L72.792 17.0914H62.0356V14.6882H78.7821V14.7266H78.7693Z",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.978 28.9278L139.454 21.578V28.9278H136.517V14.6882H139.454V21.5395L149.682 14.6882H154.204L143.924 21.4885L154.551 28.915H149.978V28.9278Z",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.595 28.9278L171.621 23.6103H173.102C175.91 23.6103 178.371 22.0125 178.371 19.3027V19.1109C178.371 16.3499 175.885 14.6882 172.999 14.6882H161.314V28.915H164.252V21.4885L175.267 28.915H179.595V28.9278ZM164.24 17.1041H173.05C174.146 17.1041 175.164 17.5387 175.447 18.4207C175.459 18.574 175.498 18.9447 175.498 19.3154C175.498 19.6989 175.473 20.0696 175.447 20.2102C175.151 20.9899 174.146 21.4629 173.05 21.4629H164.24V17.1041Z",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.597 26.3969V28.9278H87.6924V14.6882H102.597V17.2192H90.5394V20.2741H101.966V22.8051H90.5394V26.3842H102.597V26.3969Z",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.01 26.3969V28.9278H112.105V14.6882H127.01V17.2192H114.952V20.2741H126.379V22.8051H114.952V26.3842H127.01V26.3969Z",
    fill: "#ccc"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeekrPrimaryLogo);
export default ForwardRef;